import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { Table } from '../../../../common/table'
import { COMPONENTS } from '../../../../routers/constants'
import { RULES_TYPE } from '../../../common/constant'
import { TRACK_COMPANY_RULES_COL } from '../constant'
import classes from '../index.module.scss'
import { NameScore } from '../scoreRules/NameScore'
import { selectDataTable, selectIdsTable } from '../store/slice'
import { EmailCell } from './EmailCell'

export const TrackCompanylRules = () => {
  const ids = useSelector(selectIdsTable([RULES_TYPE.FOLLOWING_LIST]))
  const data = useSelector(selectDataTable(ids[0]))

  const getSchema = () => {
    return Object.keys(TRACK_COMPANY_RULES_COL).map((key) => {
      const title = `alertSetting.${key}`
      const colId = TRACK_COMPANY_RULES_COL[key]
      const thStyle = {
        justifyContent: [TRACK_COMPANY_RULES_COL.SEND_EMAILS].includes(colId)
          ? 'center'
          : '',
      }
      const tdStyle = {
        width: colId === TRACK_COMPANY_RULES_COL.SEND_EMAILS ? '25%' : '',
        position: 'relative',
      }

      return {
        colId,
        title,
        isI18n: true,
        thStyle,
        tdStyle,
        render: (_, { rowId }) => {
          switch (colId) {
            case TRACK_COMPANY_RULES_COL.EVENT:
              return <NameScore rowId={rowId} />
            case TRACK_COMPANY_RULES_COL.SEND_EMAILS:
              return <EmailCell rowId={rowId} />
            default:
              return ''
          }
        },
      }
    })
  }

  return (
    <>
      <Panel label={data?.groupName}>
        <Element style={{ backgroundColor: '#FFFFFF' }}>
          <Element
            className={classes.note}
            style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
          >
            <Translate value="alertSetting.TRACK_COMPANY_RULES_NOTE" />
          </Element>
          <Table ids={ids} schema={getSchema()} autoHeightMax={600} />
        </Element>
      </Panel>
      <Element className="mt1 ml2 fw600" style={{ color: '#3A414B' }}>
        <Translate value="alertSetting.VIEW_ALL_COMPANY_FOLLOWING" />
        <Link
          to={COMPONENTS.library.components.followingList.route}
          target="_blank"
        >
          <Element elementName="span" style={{ color: '#2C73E8' }}>
            <Translate value="alertSetting.CLICK_HERE" />
          </Element>
        </Link>
      </Element>
    </>
  )
}
